import React from 'react';
import { motion } from 'framer-motion';
interface Option {
  id: string;
  label: string;
  value: number;
}
interface QuizStepProps {
  question: string;
  subtitle?: string;
  options: Option[];
  onSelect: (value: number) => void;
}
export function QuizStep({
  question,
  subtitle,
  options,
  onSelect
}: QuizStepProps) {
  return <motion.div key={question} initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20
  }} transition={{
    duration: 0.4
  }} className="max-w-2xl mx-auto w-full px-4" data-id="element-72">
      <div className="mb-10 text-center" data-id="element-73">
        <h2 className="text-3xl md:text-4xl font-serif text-burgundy-800 mb-4 leading-tight" data-id="element-74">
          {question}
        </h2>
        {subtitle && <p className="text-lg text-slate-600 bg-cream-200/50 inline-block px-4 py-2 rounded-lg" data-id="element-75">
            {subtitle}
          </p>}
      </div>

      <div className="space-y-4" data-id="element-76">
        {options.map((option, index) => <motion.button key={option.id} initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: index * 0.1,
        duration: 0.3
      }} onClick={() => onSelect(option.value)} className="w-full text-left p-6 rounded-2xl bg-white border-2 border-cream-200 hover:border-burgundy-400 hover:bg-burgundy-50/30 transition-all duration-300 shadow-sm hover:shadow-md group flex items-center justify-between" data-id="element-77">
            <span className="text-lg md:text-xl text-slate-700 group-hover:text-burgundy-800 font-medium transition-colors" data-id="element-78">
              {option.label}
            </span>
            <div className="w-6 h-6 rounded-full border-2 border-cream-300 group-hover:border-burgundy-500 flex items-center justify-center transition-colors" data-id="element-79">
              <div className="w-2.5 h-2.5 rounded-full bg-burgundy-500 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-80" />
            </div>
          </motion.button>)}
      </div>
    </motion.div>;
}